import { render, staticRenderFns } from "./tongyong.vue?vue&type=template&id=2d3744f5&"
import script from "./tongyong.vue?vue&type=script&lang=js&"
export * from "./tongyong.vue?vue&type=script&lang=js&"
import style0 from "./tongyong.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports